import { GetterTree } from 'vuex';

import { RootStateI } from '../state';
import { VideoStreamStateI } from './state';

export const getters: GetterTree<VideoStreamStateI, RootStateI> = {};
